import { render, staticRenderFns } from "./DialogCreateUserGroup.vue?vue&type=template&id=48275a33&scoped=true&"
import script from "./DialogCreateUserGroup.vue?vue&type=script&lang=js&"
export * from "./DialogCreateUserGroup.vue?vue&type=script&lang=js&"
import style0 from "./DialogCreateUserGroup.vue?vue&type=style&index=0&id=48275a33&lang=scss&scoped=true&"
import style1 from "./DialogCreateUserGroup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48275a33",
  null
  
)

export default component.exports